<template lang="pug">
//- for PI only
.container
  .row
    h1.main_title {{$route.name}} Production Detail
    .col-md-6
      bs-input(:value.sync="searchContent" label="" type="text")
        v-select(slot="before" v-bind:value.sync="searchBar.value" v-bind:options="searchBar.opts")
        //- dropdown(slot="before" text="dropdown")
          li
            a(href="#") option
        span(slot="after" class="input-group-addon")
          span.glyphicon.glyphicon-search
          //- button(type="button" class="btn btn-info") Search
    .col-md-12.clearfix.col-centered.log_table
      pagination(
        v-bind:count-of-page.sync="countOfPage"
        v-bind:curr-page.sync="currPage"
        v-bind:count-of-pagination="countOfPagination"
        v-bind:curr-pagination-sec.sync='currPaginationSec'
        v-bind:target-ary.sync='outputData'
        v-if="outputData.length > 10")
      table.table.table-hover.table-bordered
        tr
          th Time
          th Serial Number
          th Mac address
          th Domain
          th Model
          th Version
          th
        tr(v-for="l in outputData | orderBy 'startedAt' -1 | limitBy countOfPage pageStart")
          td {{l.startedAt | timeFormat}}
          td {{l['.key']}}
          td {{l.mac}}
          td.text-capitalize {{l.domain}}
          td {{l.model}}
          td {{l.fwVersion}}
          td
            .btn-group
              button.btn.btn-default(@click="showEditForm(l)")
                span.glyphicon.glyphicon-pencil
              button.btn.btn-default(@click="showDeleteConfirm(l)")
                span.glyphicon.glyphicon-trash
    .container
      modal(
        v-bind:show.sync="modalStatus"
        v-bind:title="modalTitle"
        v-bind:large="modalSize.large"
        v-bind:small="modalSize.small"
      )
        .modal-body(slot="modal-body")
          .default_modal_content(v-if="modalPurpose === null") Hello world
          .edit_modal_content(v-if="modalPurpose === 'edit'")
            .form-horizontal
              .form-group
                label.col-sm-3.control-label(for="inputTime") Time
                .col-sm-9
                  input.form-control(
                    type="text"
                    id="inputTime"
                    v-model="modalData.startedAt"
                    disabled
                  )
              .form-group
                label.col-sm-3.control-label(for="inputSerialNumber") Serial Number
                .col-sm-9
                  input.form-control(
                    type="text"
                    id="inputSerialNumber"
                    v-model="modalData['.key']"
                    disabled
                  )
              .form-group
                label.col-sm-3.control-label(for="inputMac") Mac address
                .col-sm-9
                  input.form-control(
                    type="text"
                    id="inputMac"
                    v-model="modalData.mac"
                    disabled
                  )
              .form-group
                label.col-sm-3.control-label(for="inputModel") Domain
                .col-sm-9
                  v-select.btn-group.btn-group-justified(
                    v-bind:options=`[
                      {label: 'Intri', value: 'intri'},
                      {label: 'Eagleyes', value: 'eagleyes'},
                      {label: 'EvoIP', value: 'evoip'},
                      {label: 'AV Media', value: 'avmedia'}
                    ]`
                    v-bind:value.sync='modalData.domain')
              .form-group
                label.col-sm-3.control-label(for="inputModel") Model
                .col-sm-9
                  v-select.btn-group.btn-group-justified(
                    v-bind:options=`[
                      {label: 'ASPEED', value: 'aspeed'},
                      {label: 'ITE', value: 'ite'}
                    ]`
                    v-bind:value.sync='modalData.model')
              .form-group
                label.col-sm-3.control-label(for="inputVersion") Version
                .col-sm-9
                  input.form-control(
                    type="text"
                    id="inputVersion"
                    v-model="modalData.fwVersion"
                  )
          .delete_comfirm_content(v-if="modalPurpose === 'deleteConfirm'")
            h4
              | This operation is
              span.warning irreversible!
            h4 Do you really want to continue?
        .modal-footer(
          v-bind:class="{ 'hide': modalMethod === null }"
          slot="modal-footer"
        )
          .confirm(v-if="modalMethod === 'confirm'")
            .pull-right
              button.btn.btn-default(@click="closeModal") Cancel
              button.btn.btn-danger(@click="deleteData") Confirm
          .edit(v-if="modalMethod === 'edit'")
            .pull-right
              button.btn.btn-default(@click="closeModal") Cancel
              button.btn.btn-primary(@click="saveEdittedData") Save

</template>

<script>
import _ from 'lodash'
import { getSmartCtrlRef } from '../../index.js'
import pagination from '../common/Pagination.vue'
import { dropdown, input, modal, select } from 'vue-strap'

export default {
  components: {
    'bs-input': input,
    dropdown,
    pagination,
    modal,
    'v-select': select
  },
  data () {
    return {
      countOfPage: 10,
      currPage: 1,
      countOfPagination: 5,
      currPaginationSec: 1,
      /* modal setting */
      modalStatus: false,
      modalPurpose: null,
      modalMethod: null,
      modalTitle: 'Hello',
      modalSize: {
        large: false,
        small: false
      },
      modalData: [],
      /* search */
      searchBar: {
        opts: [
          {
            label: 'Serial Number',
            value: '.key'
          },
          {
            label: 'Mac',
            value: 'mac'
          }
        ],
        value: '.key'
      },
      searchContent: ''
    }
  },
  ready () {
  },
  firebase () {
    return {
      pi: getSmartCtrlRef()
    }
  },
  computed: {
    pageStart () {
      return (this.currPage - 1) * this.countOfPage
    },
    outputData () {
      const pi = this.pi
      /* search filter */
      const searchColumn = this.searchBar.value
      const searchContent = this.searchContent
      return pi.filter(p => {
        return searchContent !== '' ? _.includes(_.toLower(p[searchColumn]), _.toLower(searchContent)) : true
      })
    }
  },
  methods: {
    closeModal () {
      this.modalStatus = false
    },
    deleteData () {
      const targetKey = this.modalData['.key']
      this.$firebaseRefs.pi.child(targetKey).remove()
      this.closeModal()
    },
    saveEdittedData () {
      const key = this.modalData['.key']
      const { domain, model, fwVersion } = {...this.modalData}
      this.$firebaseRefs.pi.child(key).update({ domain, model, fwVersion })
      this.closeModal()
    },
    showDeleteConfirm (targetKey) {
      this.modalPurpose = 'deleteConfirm'
      this.modalMethod = 'confirm'
      this.modalTitle = 'Warning!'
      this.modalData = targetKey
      this.modalStatus = true
    },
    showEditForm (originalData) {
      this.modalPurpose = 'edit'
      this.modalMethod = 'edit'
      this.modalTitle = 'Edit Production'
      this.modalData = {...originalData}
      this.modalStatus = true
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.table{
  & th, & td {
    text-align: center;
  }
  & th {
    background-color: #f8f8f8;
  }
}
.warning{
  background-color: #f00;
  color: #fff;
  padding: 3px 5px;
}
h1{
  text-transform: capitalize;
}
.total{
  padding-top: 1px;
  text-align: right;
}
.log_table{
  display:inline-block;
}
</style>



// WEBPACK FOOTER //
// Production.vue?3eed5071